import { lazy, Suspense } from "react";

// Lazy load all modals and action bar
const NewsFeedSettingsPanel = lazy(
  () =>
    import("@/components/news-feed/news-feed-settings/NewsFeedSettingsPanel"),
);
const ArticlesActionBar = lazy(
  () => import("@/components/news-feed/action-bars/ArticlesActionBar"),
);
const CreateKeyMessageGroupModal = lazy(
  () => import("./key-message-management-modals/CreateKeyMessageGroupModal"),
);
const CreateKeyMessageModal = lazy(
  () => import("./key-message-management-modals/CreateKeyMessageModal"),
);
const DeleteArticleModal = lazy(
  () => import("./article-management-modals/DeleteArticleModal"),
);
const EditArticleModal = lazy(
  () => import("./article-management-modals/EditArticleModal"),
);
const SaveSearchAsKeyMessageModal = lazy(
  () => import("./key-message-management-modals/SaveSearchAsKeyMessageModal"),
);
const DeleteKeyMessageOrGroupModal = lazy(
  () => import("./key-message-management-modals/DeleteKeyMessageOrGroupModal"),
);
const KeyMessageInsightsModal = lazy(
  () => import("./key-message-insight-modal/KeyMessageInsightsModal"),
);
const CreateEditSaveView = lazy(
  () => import("./saved-view-management-modals/CreateEditSaveView"),
);
const DeleteSavedViewModal = lazy(
  () => import("./saved-view-management-modals/DeleteSavedViewModal"),
);
const DeleteNarrativeClusterModal = lazy(
  () =>
    import("./narrative-cluster-management-modals/DeleteNarrativeClusterModal"),
);
const RenameNarrativeClusterModal = lazy(
  () =>
    import("./narrative-cluster-management-modals/RenameNarrativeClusterModal"),
);
const RenameArticleTagModal = lazy(
  () => import("./article-tag-management-modals/RenameArticleTagModal"),
);
const DeleteArticleTagModal = lazy(
  () => import("./article-tag-management-modals/DeleteArticleTagModal"),
);
const RemoveArticlesFromNarrativeCluster = lazy(
  () =>
    import("./article-management-modals/RemoveArticlesFromNarrativeCluster"),
);
const MoveArticleFromNarrativeCluster = lazy(
  () => import("./article-management-modals/MoveArticleFromNarrativeCluster"),
);
const BulkMergeAndDeleteNarrativeClusters = lazy(
  () =>
    import(
      "./narrative-cluster-management-modals/BulkMergeAndDeleteNarrativeClusters"
    ),
);
const NarrativeInsightModalWrapper = lazy(
  () => import("@/components/news/feed/modals/NarrativeInsightModalWrapper"),
);

/**
 * House all the news feed modals and modal states here.
 */
const NewsFeedModals = () => {
  return (
    <Suspense fallback={null}>
      {/* Sheets UI Components */}
      <NewsFeedSettingsPanel />

      {/* Modals UI Components */}
      <SaveSearchAsKeyMessageModal />
      <CreateKeyMessageModal />
      <CreateKeyMessageGroupModal />
      <DeleteKeyMessageOrGroupModal />
      <KeyMessageInsightsModal />
      <DeleteArticleModal />
      <EditArticleModal />
      <CreateEditSaveView />
      <DeleteSavedViewModal />
      <DeleteNarrativeClusterModal />
      <RenameNarrativeClusterModal />
      <RenameArticleTagModal />
      <DeleteArticleTagModal />
      <RemoveArticlesFromNarrativeCluster />
      <MoveArticleFromNarrativeCluster />
      <BulkMergeAndDeleteNarrativeClusters />
      <NarrativeInsightModalWrapper />

      {/* Article action bar */}
      <ArticlesActionBar />
    </Suspense>
  );
};

export default NewsFeedModals;
